import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import AssetType, { newAssetType } from "../../models/asset-type";
import AssetTypeForm from "./AssetTypeForm";

interface AssetTypeUpdateModalProps {
  show: boolean;
  assetType?: AssetType;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AssetTypeUpdateModal: React.FC<AssetTypeUpdateModalProps> = ({
  show,
  assetType,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialAssetType, setInitialAssetType] = useState<AssetType>(
    assetType ? assetType : newAssetType()
  );

  const modalTitle = assetType
    ? `Editar Tipo de productor: ${assetType.name}`
    : `Crear Tipo de productor nuevo`;

  const onClose = () => {
    setInitialErrors({});
    setInitialAssetType(newAssetType());
    onCancel();
  };
  useEffect(() => {
    setInitialAssetType(assetType ? assetType : newAssetType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetType]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <AssetTypeForm
            initialAssetType={initialAssetType}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AssetTypeUpdateModal;
